module.exports = __webpack_public_path__ + "media/images/users/user-5-3aa73cd466bca08cec9942e11a2bb973.jpg";